/**
 * Métadonnée des mutations publiques ou des flows d'auth qui gèrent eux-mêmes
 * leurs erreurs. Une 401 sur ces mutations ne prouve jamais qu'une session ERP
 * courante a été révoquée (mot de passe faux, token expiré, etc.).
 */
export const MUTATION_SANS_RECUPERATION_SESSION_META = {
  ignorerRecuperationSession: true,
} as const;

interface MutationAvecMeta {
  meta?: Record<string, unknown>;
}

export function mutationIgnoreRecuperationSession(mutation: MutationAvecMeta): boolean {
  return mutation.meta?.["ignorerRecuperationSession"] === true;
}

/** Une ancienne identité mémorisée ne suffit pas : il faut le `auth.me` courant. */
export function sessionCouranteProuvee(me: unknown): boolean {
  if (!me || typeof me !== "object") return false;
  const utilisateur = (me as { utilisateur?: unknown }).utilisateur;
  if (!utilisateur || typeof utilisateur !== "object") return false;
  const id = (utilisateur as { id?: unknown }).id;
  return typeof id === "string" && id.length > 0;
}
